module.exports = __webpack_public_path__ + "2291c583dc7f7dbf77ba42a0c8683f7d.svg";